var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadDepressed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102px",
    height: "126px",
    viewBox: "0 0 102 126",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5A5D0021-C081-43F8-B38A-26317DEEB825") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.-side-effects",
    transform: "translate(-938.000000, -375.000000)",
    strokeWidth: 4.19999975
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(903.000000, 378.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(38.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.3371267,120.731333 C55.3371267,114.136133 53.7981268,103.228434 72.1467257,106.073334 C80.3181252,107.344434 81.9081251,90.3383346 84.306625,85.4000349 C85.3998249,83.160835 86.6454248,81.4274351 89.2290247,80.9654352 C91.1100246,80.6276352 93.2457244,81.2516352 94.8330243,79.8881352 C96.1593243,78.7607353 96.4485243,76.7828354 95.8986243,75.1856355 C95.8986243,75.1856355 91.2510246,65.9072361 86.6130248,58.4012365 C83.377525,53.1743368 85.0023249,48.3536371 85.0023249,42.5069375 C85.0023249,19.0280389 65.9742261,0.000239999986 42.5067275,0.000239999986 C19.0326289,0.000239999986 2.99999982e-05,19.0280389 2.99999982e-05,42.5069375 C2.99999982e-05,49.943637 1.92032989,56.9408366 5.31512968,63.0926362 C16.710329,85.1066349 14.9997291,120.731333 14.9997291,120.731333",
    id: "Stroke-1",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5902166,47.1753872 C63.3184162,46.5348872 67.810316,41.6409875 67.810316,35.7480879 L67.810316,35.3094879 C67.810316,28.9851883 62.6362163,23.8110886 56.3128166,23.8110886 L53.3881168,23.8110886 L53.3881168,22.9113886 C53.3881168,16.440689 48.1426171,11.1936893 41.6719175,11.1936893 C35.2015179,11.1936893 29.9560182,16.440689 29.9560182,22.9113886 L29.9560182,23.6544886",
    id: "Stroke-3",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0118579,27.3926684 C32.5737581,24.8552685 30.4608582,23.8163686 26.7966584,23.8163686 L26.2275584,23.8388686 C20.2746588,24.2567686 15.5340591,29.2565683 15.5340591,35.3096679 L15.5340591,35.7482679 C15.5340591,40.2407676 18.1443589,44.1527674 21.9222587,46.0427673",
    id: "Stroke-5",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.9537874,
    y1: 40.0571376,
    x2: 30.6858882,
    y2: 65.9549361,
    id: "Stroke-7",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.7532879,
    y1: 40.0571376,
    x2: 25.7244885,
    y2: 59.1173365,
    id: "Stroke-9",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.149007,
    y1: 40.0571376,
    x2: 42.1202075,
    y2: 59.1173365,
    id: "Stroke-11",
    stroke: "#ED7330"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadDepressed);
export default __webpack_public_path__ + "static/media/headDepressed.ed68f6cd.svg";
export { ForwardRef as ReactComponent };